import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'any'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.isAuthenticated()) {
      this.authService.checkIsLogin().then();
      return false;
    }

    const requiredRoles = next.data?.['roles'] as string[] | undefined;
    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    const hasRole = await this.authService.hasAnyRole(requiredRoles);
    if (hasRole) {
      return true;
    }

    // Không đủ quyền: chuyển về trang không có quyền truy cập
    this.router.navigate(['/unauthorized']);
    return false;
  }
}
